module.exports = __webpack_public_path__ + "img/syzn_03.2738b21d.jpg";